import { StateCreator } from "zustand";
import { Middleware, StoreState } from "@/stores/global-store";
import { EntitlementItem } from "@/features/auth/types/permissions";

/* Store Types */
type Theme = "dark" | "light";
export interface AppSettingsSlice {
  theme: Theme;
  entitlements: EntitlementItem[];
  appActions: {
    setTheme: (theme: Theme) => void;
    setEntitlements: (entitlements: EntitlementItem[]) => void;
  };
}

/*
 * The appSettingsSlice is a slice of the global zustand store that contains the app settings.
 */
export const appSettingsSlice: StateCreator<StoreState, Middleware, [], AppSettingsSlice> = (set) => ({
  // Get the theme from local storage or default to dark
  theme: (localStorage.getItem("theme") as Theme) || "dark",
  entitlements: [],

  /* Actions */
  appActions: {
    setTheme: (theme: Theme) => set({ theme }),
    setEntitlements: (entitlements: EntitlementItem[]) => set({ entitlements }),
  },
});
